import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { useNotification } from '@/contexts/WebsocketProvider/Notification.provider';
import { UserNotification } from '@/core/domain/communication/userNotification/userNotification.types';
import { useEffect } from 'react';

const InvalidAfterNotification = () => {
  const notification = useNotification();
  const queryChanel = useQueryChanel();

  useEffect(() => {
    const userNotification = (notification.userNotification ||
      {}) as UserNotification;
    const message = userNotification.message;
    const entityId = userNotification.entityId;

    if (
      entityId &&
      message === 'Importação dos itens do inventário concluída.'
    ) {
      queryChanel({
        invalidateQueries: [
          ['inventories'],
          ['itemsInventory'],
          ['inventories', entityId],
          ['allInventory', entityId],
        ],
      });
    }
  }, [notification?.userNotification]);

  return null;
};

export default InvalidAfterNotification;
